import {
    addItemToCollection
} from "directus/src/operations";

export async function createOutcome({ item }) {
    try {
        const query = {
            fields: [
                "id",
                "description",
                "type",
                "case_study.id",
            ],
        };
        const data = await addItemToCollection("outcomes", item, query);
        return data;
    } catch (error) {
        console.log(error);
        throw error;
    }
}